// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1uDXa","ranges":"BmiRanges_ranges__1j99-"};